const PasswordPatterns = [
    {
        regex: RegExp('(?=.*[A-Z])'),
        label: 'Contain one uppercase alphabetical character.'
    }, {
        regex: RegExp('(?=.*[a-z])'),
        label: 'Contain one lowercase alphabetical character.'
    }, {
        regex: RegExp('(?=.*[0-9])'),
        label: 'Contain one numeric character.'
    }, {
        regex: RegExp("(?=.[!@#\$%\^&])"),
        label: 'Contain one of the following: !@#$%^&'
    }, {
        regex: RegExp('(?=.{8,})'),
        label: 'Be at least 8 characters long.'
    }
];

export default PasswordPatterns;
